(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[260],{

/***/ 65300:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/app/writer",
      function () {
        return __webpack_require__(88785);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyClipboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73400);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41997);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34386);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83321);
/* harmony import */ var _Iconify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42445);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10653);









function CopyClipboard(param) {
    var value = param.shareInputValue, inputProps = param.inputProps, onShareInputValueChange = param.onShareInputValueChange;
    var isMobile = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("down", "sm");
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        value: value,
        copied: false
    }), state = ref[0], setState = ref[1];
    var handleChange = function(event) {
        var newVal = event.target.value;
        setState({
            value: newVal,
            copied: false
        });
        if (onShareInputValueChange) {
            onShareInputValueChange(newVal);
        }
    };
    var onCopy = function() {
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
            copied: true
        }));
        if (state.value) {
            enqueueSnackbar("Copied!");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                fullWidth: true,
                multiline: true,
                maxRows: 15,
                value: state.value,
                onChange: handleChange,
                InputProps: {
                    endAdornment: isMobile ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        position: "end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                            text: state.value,
                            onCopy: onCopy,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                title: "Copy",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: "eva:copy-fill",
                                        width: 24,
                                        height: 24
                                    })
                                })
                            })
                        })
                    })
                }
            }, inputProps)),
            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                text: state.value,
                onCopy: onCopy,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    fullWidth: true,
                    variant: "outlined",
                    sx: {
                        mt: 1
                    },
                    children: "Copy to Clipboard"
                })
            })
        ]
    });
}


/***/ }),

/***/ 88785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ WriterPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(40549);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61582);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29430);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42445);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25168);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(64666);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(58951);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(31425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(98456);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(67358);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(38895);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(22797);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(41997);
/* harmony import */ var _sections_landing_Shares__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29608);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76843);
/* harmony import */ var _components_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48727);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(31812);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47533);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var _components_LoadingScreen__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12030);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _components_CopyClipboard__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50107);
/* harmony import */ var _theme_palette__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78187);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78470);
/* harmony import */ var _theme_layout__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9671);










function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-gap: 30px;\n  grid-template-columns: repeat(4, 1fr);\n  max-width: ",
        "px;\n  margin: auto;\n  @media (max-width: 768px) {\n    max-width: 100%;\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 30px;\n  display: grid;\n  grid-gap: 30px;\n  grid-template-columns: repeat(3, 1fr);\n  width: 100%;\n  margin: auto;\n  @media (max-width: 768px) {\n    max-width: 100%;\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-gap: 30px;\n  grid-template-columns: repeat(5, 1fr);\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    cursor: default;\n  }\n  background: ",
        " !important;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-gap: 15px;\n  grid-template-columns: repeat(1, 1fr);\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}























var defaultDialogValues = {
    toneId: "60572a639bdd4272b8fe358b",
    languageId: "60f853a39bb0df0013c6a588",
    useCaseId: "605838118c0a4a000c69c968"
};
var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9298d3a4-0"
})(_templateObject());
var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9298d3a4-1"
})(_templateObject1());
var CardsContainer = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9298d3a4-2"
})(_templateObject2(), _theme_layout__WEBPACK_IMPORTED_MODULE_19__/* ["default"].maxWidth.desktop */ .Z.maxWidth.desktop);
var OutputsContainer = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9298d3a4-3"
})(_templateObject3());
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(3)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11),
        paddingBottom: theme.spacing(5)
    });
});
var ContentStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        overflow: "hidden",
        position: "relative"
    };
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-9298d3a4-4"
})(_templateObject4());
WriterPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
function IsolateReset(param) {
    var methods = param.methods;
    var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        control: methods.control,
        name: "useCaseId",
        defaultValue: ""
    });
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        var values = methods.getValues();
        methods.reset();
        Object.keys(values).forEach(function(key) {
            if (Object.keys(defaultDialogValues).includes(key)) {
                var thisKey = key;
                methods.setValue(thisKey, values[thisKey]);
            }
        });
    }, [
        methods,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
}
var DialogComponent = function(props) {
    var ref;
    var user = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)().user;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useUserCreateStripeCheckoutSessionsMutation */ .Wmf)(), 2), userCreateStripeCheckoutSessionsMutation = ref1[0], ref2 = ref1[1], createStripeCheckoutSessionsLoading = ref2.loading;
    var ref3 = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useUserFetchActiveSubscriptionByAuth0IdQuery */ .esI)((user === null || user === void 0 ? void 0 : user.sub) ? {
        variables: {
            auth0Id: user.sub
        }
    } : {
        skip: true
    }), userFetchActiveSubscriptionData = ref3.data, userFetchActiveSubscriptionLoading = ref3.loading;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(false), isOpen = ref4[0], setIsOpen = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)([]), useCases = ref5[0], setUseCases = ref5[1];
    var ref6 = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useFetchBasicSetupConfigQuery */ .AHv)(), fetchBasicSetupConfigQuery = ref6.data, fetchBasicSetupConfigQueryLoading = ref6.loading;
    var CommentSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
        toneId: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Tone is required"),
        languageId: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Language is required"),
        useCaseId: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Use Case is required")
    });
    var defaultValues = props.fragment.__typename === "SupportingUseCase" ? {
        useCaseId: props.fragment._id,
        languageId: defaultDialogValues.languageId,
        toneId: defaultDialogValues.toneId
    } : props.fragment.__typename === "SupportingLanguage" ? {
        useCaseId: defaultDialogValues.useCaseId,
        languageId: props.fragment._id,
        toneId: defaultDialogValues.toneId
    } : props.fragment.__typename === "SupportingTone" ? {
        useCaseId: defaultDialogValues.useCaseId,
        languageId: defaultDialogValues.languageId,
        toneId: props.fragment._id
    } : {
        useCaseId: defaultDialogValues.useCaseId,
        languageId: defaultDialogValues.languageId,
        toneId: defaultDialogValues.toneId
    };
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_11__/* .yupResolver */ .X)(CommentSchema),
        defaultValues: defaultValues
    });
    var handleSubmit = methods.handleSubmit, watch = methods.watch, isSubmitting = methods.formState.isSubmitting;
    var handleClose = function() {
        setIsOpen(false);
        setUseCases([]);
    };
    var isSubscribed = Boolean(userFetchActiveSubscriptionData === null || userFetchActiveSubscriptionData === void 0 ? void 0 : userFetchActiveSubscriptionData.subscriptions.length);
    var handleSubscribe = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(function() {
            var ref, data, ref1, redirectUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_26__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isSubscribed) return [
                            2
                        ];
                        return [
                            4,
                            userCreateStripeCheckoutSessionsMutation()
                        ];
                    case 1:
                        data = _state.sent().data;
                        redirectUrl = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.createStripeCheckoutSessions) === null || ref === void 0 ? void 0 : ref.redirectUrl) !== null && ref1 !== void 0 ? ref1 : null;
                        if (redirectUrl) {
                            window.location.assign(redirectUrl);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubscribe() {
            return _ref.apply(this, arguments);
        };
    }();
    if (fetchBasicSetupConfigQueryLoading || userFetchActiveSubscriptionLoading) return null;
    var ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                variant: "outlined",
                fullWidth: true,
                onClick: function() {
                    return setIsOpen(true);
                },
                children: "Writersoft"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                fullScreen: true,
                open: isOpen,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                        id: "alert-dialog-title",
                        children: "AI Writer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                id: "alert-dialog-description",
                                children: "AI Writer is a tool that lets you automatically generate high-quality content for various"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .FormProvider */ .RV, {
                                methods: methods,
                                onSubmit: handleSubmit(function(data) {
                                    var languageId = data.languageId, toneId = data.toneId, useCaseId = data.useCaseId, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(data, [
                                        "languageId",
                                        "toneId",
                                        "useCaseId"
                                    ]);
                                    var ref;
                                    var language = lodash__WEBPACK_IMPORTED_MODULE_12___default().find((ref = fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingLanguages) !== null && ref !== void 0 ? ref : [], {
                                        _id: languageId
                                    });
                                    var ref1;
                                    var tone = lodash__WEBPACK_IMPORTED_MODULE_12___default().find((ref1 = fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingTones) !== null && ref1 !== void 0 ? ref1 : [], {
                                        _id: toneId
                                    });
                                    var ref2;
                                    var useCase = lodash__WEBPACK_IMPORTED_MODULE_12___default().find((ref2 = fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingUseCases) !== null && ref2 !== void 0 ? ref2 : [], {
                                        _id: useCaseId
                                    });
                                    if (!language || !tone || !useCase) return Promise.resolve("");
                                    var restData = rest;
                                    var contextInputs = Object.keys(restData).map(function(keyLabel) {
                                        var ref;
                                        var input = (ref = lodash__WEBPACK_IMPORTED_MODULE_12___default().find(useCase.contextInputs, {
                                            keyLabel: keyLabel
                                        })) !== null && ref !== void 0 ? ref : {};
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, input), {
                                            inputValue: restData[keyLabel]
                                        });
                                    }).map(function(contextInput) {
                                        var __typename = contextInput.__typename, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(contextInput, [
                                            "__typename"
                                        ]);
                                        return rest;
                                    }).map(function(contextInput) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, contextInput), {
                                            inputValue: contextInput.isRequired && !contextInput.inputValue ? "Writersoft" : contextInput.inputValue
                                        });
                                    });
                                    setUseCases(function(useCases) {
                                        return [
                                            {
                                                id: moment__WEBPACK_IMPORTED_MODULE_15___default()().format("x"),
                                                variables: {
                                                    inputs: [
                                                        {
                                                            id: moment__WEBPACK_IMPORTED_MODULE_15___default()().format("x"),
                                                            format: _generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .Format.Text */ .EDR.Text,
                                                            language: {
                                                                _id: language._id,
                                                                slug: language.slug
                                                            },
                                                            retryTimes: 3,
                                                            tone: {
                                                                _id: tone._id,
                                                                slug: tone.slug
                                                            },
                                                            variations: 1,
                                                            useCase: {
                                                                _id: useCase._id,
                                                                slug: useCase.slug,
                                                                contextInputs: contextInputs
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)(useCases));
                                    });
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                                    spacing: 3,
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IsolateReset, {
                                            methods: methods
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFSelect */ .Cc, {
                                            name: "languageId",
                                            label: "Language",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                    disabled: true,
                                                    value: "disabled",
                                                    children: "Select one"
                                                }),
                                                fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingLanguages.map(function(supportingLanguage) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                        label: supportingLanguage.name,
                                                        value: supportingLanguage._id,
                                                        children: supportingLanguage.name
                                                    }, supportingLanguage._id);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFSelect */ .Cc, {
                                            name: "toneId",
                                            label: "Tone",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                    disabled: true,
                                                    value: "disabled",
                                                    children: "Select one"
                                                }),
                                                fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingTones.map(function(supportingTone) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                        label: supportingTone.name,
                                                        value: supportingTone._id,
                                                        children: supportingTone.name
                                                    }, supportingTone._id);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFSelect */ .Cc, {
                                            name: "useCaseId",
                                            label: "Use Case",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                    disabled: true,
                                                    value: "disabled",
                                                    children: "Select one"
                                                }),
                                                fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingUseCases.map(function(supportingUseCase) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                        label: supportingUseCase.name,
                                                        value: supportingUseCase._id,
                                                        children: supportingUseCase.name
                                                    }, supportingUseCase._id);
                                                })
                                            ]
                                        }),
                                        (ref = lodash__WEBPACK_IMPORTED_MODULE_12___default().find((ref7 = fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingUseCases) !== null && ref7 !== void 0 ? ref7 : [], {
                                            _id: watch("useCaseId")
                                        })) === null || ref === void 0 ? void 0 : ref.contextInputs.map(function(contextInput) {
                                            switch(contextInput.inputType){
                                                case "textarea":
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFTextField */ .au, {
                                                        placeholder: contextInput.placeholder,
                                                        name: contextInput.keyLabel,
                                                        label: contextInput.label,
                                                        multiline: true,
                                                        maxRows: 3
                                                    }, contextInput._id);
                                                case "text":
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFTextField */ .au, {
                                                        name: contextInput.keyLabel,
                                                        placeholder: contextInput.placeholder,
                                                        label: contextInput.label
                                                    }, contextInput._id);
                                                default:
                                                    break;
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                            disabled: !isSubscribed,
                                            fullWidth: true,
                                            type: "submit",
                                            variant: "contained",
                                            loading: isSubmitting,
                                            children: "Generate"
                                        }),
                                        !isSubscribed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                            variant: "contained",
                                            size: "large",
                                            onClick: handleSubscribe,
                                            loading: createStripeCheckoutSessionsLoading,
                                            children: "Subscribe Then Enjoy"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OutputsContainer, {
                                children: useCases.map(function(useCase, useCaseIndex) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OutputComponent, {
                                        onRemove: function() {
                                            return setUseCases(function(useCases) {
                                                return useCases.filter(function(_, index) {
                                                    return index !== useCaseIndex;
                                                });
                                            });
                                        },
                                        variables: useCase.variables,
                                        title: "#".concat(useCaseIndex + 1, " (").concat(moment__WEBPACK_IMPORTED_MODULE_15___default()(Number(useCase.id)).format("YYYY-MM-DD HH:mm:ss"), ")")
                                    }, useCase.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            variant: "outlined",
                            onClick: handleClose,
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};
var UseCasesSection = function(props) {
    var ref;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RootStyle, {
        theme: theme,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
                component: _components_animate__WEBPACK_IMPORTED_MODULE_9__/* .MotionViewport */ .DG,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_8__/* .TopLandingSection */ .k, {
                    title: "Use Cases",
                    subtitle: "AI writer that lets you automatically generate high-quality content for various use cases."
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
                component: _components_animate__WEBPACK_IMPORTED_MODULE_9__/* .MotionViewport */ .DG,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardsContainer, {
                    children: (ref = props.data) === null || ref === void 0 ? void 0 : ref.supportingUseCases.map(function(supportingUseCase) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCard, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
                                            alt: supportingUseCase.name,
                                            src: "/api/image/".concat(supportingUseCase.image)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                mt: 2,
                                                mb: 0.5
                                            },
                                            children: supportingUseCase.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                            variant: "body2",
                                            sx: {
                                                mb: 2,
                                                color: "text.secondary"
                                            },
                                            children: supportingUseCase.caption
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                            variant: "body2",
                                            sx: {
                                                mb: 2,
                                                color: "text.secondary"
                                            },
                                            children: supportingUseCase.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogComponent, {
                                    fragment: supportingUseCase
                                })
                            ]
                        }, supportingUseCase._id);
                    })
                })
            })
        ]
    });
};
var SupportingLanguagesSection = function(props) {
    var ref;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RootStyle, {
        theme: theme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
            component: _components_animate__WEBPACK_IMPORTED_MODULE_9__/* .MotionViewport */ .DG,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_8__/* .TopLandingSection */ .k, {
                    title: "Supporting Languages",
                    subtitle: "Supporting languages for AI writer that lets you automatically generate high-quality content for various use cases."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardsContainer, {
                    children: (ref = props.data) === null || ref === void 0 ? void 0 : ref.supportingLanguages.map(function(supportingLanguage) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCard, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: supportingLanguage.name
                            })
                        }, supportingLanguage._id);
                    })
                })
            ]
        })
    });
};
var SupportingTonesSection = function(props) {
    var ref;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RootStyle, {
        theme: theme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
            component: _components_animate__WEBPACK_IMPORTED_MODULE_9__/* .MotionViewport */ .DG,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_8__/* .TopLandingSection */ .k, {
                    title: "Supporting Tones",
                    subtitle: "Supporting tones for AI writer that lets you automatically generate high-quality content for various use cases."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardsContainer, {
                    children: (ref = props.data) === null || ref === void 0 ? void 0 : ref.supportingTones.map(function(supportingTone) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCard, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: supportingTone.name
                            })
                        }, supportingTone._id);
                    })
                })
            ]
        })
    });
};
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9298d3a4-5"
})(_templateObject5());
var OutputComponentStyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP)(StyledCard).withConfig({
    componentId: "sc-9298d3a4-6"
})(_templateObject6(), _theme_palette__WEBPACK_IMPORTED_MODULE_17__/* ["default"].light.grey[200] */ .ZP.light.grey[200]);
var InputsContainer = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9298d3a4-7"
})(_templateObject7());
var OutputComponent = function(props) {
    var ref = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useFetchWriterGenericsQuery */ .eq_)({
        variables: props.variables,
        fetchPolicy: "no-cache"
    }), fetchWriterGenericsQueryData = ref.data, fetchWriterGenericsQueryLoading = ref.loading;
    var ref1;
    var data = lodash__WEBPACK_IMPORTED_MODULE_12___default().first((ref1 = fetchWriterGenericsQueryData === null || fetchWriterGenericsQueryData === void 0 ? void 0 : fetchWriterGenericsQueryData.generics) !== null && ref1 !== void 0 ? ref1 : []);
    var _name, _name1, _name2;
    var displayTexts = [
        {
            label: "Use Case",
            value: (_name = data === null || data === void 0 ? void 0 : data.useCase.name) !== null && _name !== void 0 ? _name : ""
        },
        {
            label: "Language",
            value: (_name1 = data === null || data === void 0 ? void 0 : data.language.name) !== null && _name1 !== void 0 ? _name1 : ""
        },
        {
            label: "Tone",
            value: (_name2 = data === null || data === void 0 ? void 0 : data.tone.name) !== null && _name2 !== void 0 ? _name2 : ""
        }, 
    ];
    var customInput = !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z)(props.variables.inputs, Array) ? props.variables.inputs : lodash__WEBPACK_IMPORTED_MODULE_12___default().first(props.variables.inputs);
    var _inputValue;
    var customInputs = customInput === null || customInput === void 0 ? void 0 : customInput.useCase.contextInputs.map(function(contextInput) {
        return {
            label: contextInput.label,
            value: (_inputValue = contextInput.inputValue) !== null && _inputValue !== void 0 ? _inputValue : ""
        };
    });
    var _value, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(OutputComponentStyledCard, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                variant: "body1",
                style: {
                    marginBottom: 15
                },
                children: props.title
            }),
            fetchWriterGenericsQueryLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
            !fetchWriterGenericsQueryLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    icon: "eva:arrow-ios-downward-fill",
                                    width: 20,
                                    height: 20
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                    variant: "subtitle1",
                                    children: "Writersoft Variations"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputsContainer, {
                                    children: displayTexts.map(function(displayText) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z, {
                                            disabled: true,
                                            label: displayText.label,
                                            value: displayText.value,
                                            fullWidth: true
                                        }, displayText.label);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        defaultExpanded: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    icon: "eva:arrow-ios-downward-fill",
                                    width: 20,
                                    height: 20
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                    variant: "subtitle1",
                                    children: "Input Output"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputsContainer, {
                                    children: [
                                        (customInputs !== null && customInputs !== void 0 ? customInputs : []).map(function(customInput) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                shareInputValue: (_value = customInput.value) !== null && _value !== void 0 ? _value : "",
                                                inputProps: {
                                                    fullWidth: true
                                                }
                                            }, customInput.label);
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            shareInputValue: (ref2 = data === null || data === void 0 ? void 0 : data.text) !== null && ref2 !== void 0 ? ref2 : ""
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !fetchWriterGenericsQueryLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonContainer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        variant: "outlined",
                        onClick: props.onRemove,
                        children: "Remove"
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
function WriterPage(param) {
    var title = param.title, seoMetadataItemsCollection = param.seoMetadataItemsCollection, globalSettingWithWritersoftModules = param.globalSettingWithWritersoftModules;
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(), error = ref.error, isLoading = ref.isLoading, user = ref.user, login = ref.login;
    var ref1 = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .useFetchBasicSetupConfigQuery */ .AHv)(), fetchBasicSetupConfigQuery = ref1.data, fetchBasicSetupConfigQueryLoading = ref1.loading;
    var ref2;
    var companyColor = (ref2 = globalSettingWithWritersoftModules === null || globalSettingWithWritersoftModules === void 0 ? void 0 : globalSettingWithWritersoftModules.companyColor) !== null && ref2 !== void 0 ? ref2 : undefined;
    if (isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingScreen__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        companyColor: companyColor
    });
    if (error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            children: error.message
        })
    });
    if (!user) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                variant: "contained",
                size: "large",
                onClick: function() {
                    return login();
                },
                children: "點擊我登入"
            })
        });
    }
    var ref3;
    var writersoftModules = (ref3 = globalSettingWithWritersoftModules === null || globalSettingWithWritersoftModules === void 0 ? void 0 : globalSettingWithWritersoftModules.writersoftModules) !== null && ref3 !== void 0 ? ref3 : [];
    fetchBasicSetupConfigQuery === null || fetchBasicSetupConfigQuery === void 0 ? void 0 : fetchBasicSetupConfigQuery.supportingUseCases;
    var useCaseData = fetchBasicSetupConfigQuery ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)({}, fetchBasicSetupConfigQuery), {
        supportingUseCases: writersoftModules.length !== 0 ? fetchBasicSetupConfigQuery.supportingUseCases.filter(function(supportingUseCase) {
            return writersoftModules.includes(supportingUseCase.name);
        }) : fetchBasicSetupConfigQuery.supportingUseCases
    }) : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title !== null && title !== void 0 ? title : "",
        metadataItems: seoMetadataItemsCollection,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentStyle, {
                children: fetchBasicSetupConfigQueryLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingScreen__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    companyColor: companyColor
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UseCasesSection, {
                            data: useCaseData
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SupportingLanguagesSection, {
                            data: fetchBasicSetupConfigQuery
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SupportingTonesSection, {
                            data: fetchBasicSetupConfigQuery
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 29608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ RootStyle; },
/* harmony export */   "k": function() { return /* binding */ TopLandingSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76843);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32970);







var TopLandingSection = function(props) {
    var _title = props.title, title = _title === void 0 ? "" : _title, titleColor = props.titleColor, _subtitle = props.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, subtitleColor = props.subtitleColor, subtitleFontSize = props.subtitleFontSize;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (title === "" && subtitle === "") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            textAlign: "center",
            mb: 5
        },
        id: title,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inUp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "h3",
                    sx: {
                        mb: 2,
                        color: titleColor !== null && titleColor !== void 0 ? titleColor : theme.palette.primary.main
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inDown,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body1",
                    sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        mb: 2,
                        color: subtitleColor !== null && subtitleColor !== void 0 ? subtitleColor : theme.palette.grey[600]
                    }, subtitleFontSize ? {
                        fontSize: subtitleFontSize
                    } : {}),
                    children: subtitle
                })
            })
        ]
    });
};
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor || theme.palette.background.neutral,
        backgroundImage: backgroundImage,
        padding: theme.spacing(10, 2)
    }, theme.breakpoints.up("md"), {
        padding: theme.spacing(12, 0)
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,3662,6547,513,9694,1664,9463,7952,4894,1997,2679,2077,5644,5564,285,2219,9452,29,8424,6755,3907,2575,8727,9774,2888,179], function() { return __webpack_exec__(65300); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);